import { Grid, Row, Space } from 'antd'
import Button from 'app/components/UI-Elements/General/Button'
import KCol from 'app/components/UI-Elements/Layout/KCol'
import { useFeedbacker } from 'app/lib/contexts/Feedbacker'
import useTranslation from 'app/lib/hooks/useTranslation'
import { RecordTypeEnum } from 'app/queries'
import React from 'react'

import { MemberProps } from '../../convention'
import RentalCancelForm from '../Form/Cancel'

const CancelCard: React.FC<MemberProps<IRental>> = ({ member }) => {
  const { md } = Grid.useBreakpoint()
  const {
    drawerfy: { open, close }
  } = useFeedbacker()
  const { tComponent, tButtonTitle } = useTranslation({
    recordType: RecordTypeEnum.rental,
    componentType: 'data_display',
    scope: 'card'
  })

  const onClick = () => {
    open({
      recordType: RecordTypeEnum.rentalCancel,
      action: 'update',
      content: <RentalCancelForm member={member} props={{ onSuccess: close }} />,
      destroyOnClose: true,
      width: 600
    })
  }

  return (
    <Row>
      <KCol span={24} card title={tComponent({ id: 'cancel_card_title' })}>
        <Space
          direction={md ? 'horizontal' : 'vertical'}
          className="justify-content-between full-width">
          <p className="mb-0">{tComponent({ id: 'cancel_card_description' })}</p>
          <Button
            type="secondary"
            block
            onClick={onClick}
            title={tButtonTitle({ id: 'cancel_rental' })}
          />
        </Space>
      </KCol>
    </Row>
  )
}

export default CancelCard
